import { NonUndefined } from 'react-hook-form'
import { DrawerProps } from 'components/Drawer/Drawer'

export const DrawerSize: Record<NonUndefined<DrawerProps['size']>, string> = {
  small: '500px',
  medium: '750px',
  large: '900px',
}
